<template>
  <div class="Count-Comment" :class="get_modifyClasses">
    <CloudIcon class="Count-Comment__icon"/>
    <span class="Count-Comment__counter" v-if="get_isShowStaticCounter">{{ props.count }}</span>
    <span class="Count-Comment__new-counter" v-if="get_newComments > 0">+{{ get_newComments }}</span>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------
  import CloudIcon from '@svg/CloudIcon.vue';
  //--------------------------
  const props = defineProps(Props());
  //--------------------------
  //Определить классы модификаторый для элемента
  const get_modifyClasses = computed(() => props.isClickable ? 'Count-Comment--clickable' : '');
  //Отображать ли статичное кол-во комментариев
  const get_isShowStaticCounter = computed(() => props.count && props.count > 0);
  //Отображать ли статичное кол-во комментариев
  const get_isShowNewCommentsCounter = computed(() => props.newCommentsCounter && props.newCommentsCounter > 0);
  //Кол-во новых комментариев
  const get_newComments = computed(() => props.newCommentsCounter - props.count);
</script>

<style lang="scss">
  @import "./styles/_style.scss";
</style>